export const Permission = {
    // USER
    USER_READ: 'user:read',
    USER_CREATE: 'user:create',
    USER_UPDATE: 'user:update',
    USER_DELETE: 'user:delete',
    USER_MANAGE: 'user:manage',
    USER_PASSWORD_MANAGE: 'user-password:manage',

    USER_PRESENCE_READ: 'user-presence:read',

    // ROLE
    ROLE_READ: 'role:read',
    ROLE_UPDATE: 'role:update',
    ROLE_MANAGE: 'role:manage',

    // POLICY
    POLICY_READ: 'policy:read',
    POLICY_CREATE: 'policy:create',
    POLICY_UPDATE: 'policy:update',
    POLICY_DELETE: 'policy:delete',

    // ANALYTICS
    ANALYTICS_READ: 'analytics:read',
    ANALYTICS_EXPORT: 'analytics:export',

    // NOTIFICATION TEMPLATE
    NOTIFICATION_TEMPLATE_READ: 'notification-template:read',
    NOTIFICATION_TEMPLATE_CREATE: 'notification-template:create',
    NOTIFICATION_TEMPLATE_UPDATE: 'notification-template:update',
    NOTIFICATION_TEMPLATE_DELETE: 'notification-template:delete',

    // NOTIFICATION BROADCAST
    BROADCAST_READ: 'broadcast:read',
    BROADCAST_CREATE: 'broadcast:create',
    BROADCAST_UPDATE: 'broadcast:update',
    BROADCAST_DELETE: 'broadcast:delete',

    // ACCOUNT
    ACCOUNT_READ: 'account:read',
    ACCOUNT_UPDATE: 'account:update',

    // INBOX
    INBOX_READ: 'inbox:read',
    INBOX_UPDATE: 'inbox:update',
    CHAT_GROUP_MANAGE: 'chat-group:manage',

    // SEGMENT
    SEGMENT_READ: 'segment:read',
    SEGMENT_MANAGE: 'segment:manage',
    SEGMENT_CREATE: 'segment:create',
    SEGMENT_UPDATE: 'segment:update',
    SEGMENT_DELETE: 'segment:delete',

    // REQUEST
    REQUEST_READ: 'request:read',
    REQUEST_CREATE: 'request:create',
    REQUEST_UPDATE: 'request:update',
    REQUEST_DELETE: 'request:delete',
    REQUEST_APPROVE: 'request:update',
    REQUEST_REJECT: 'request:update',
    REQUEST_REVIEW: 'request:update',

    // REQUEST TYPE
    REQUEST_TYPE_READ: 'request-type:read',
    REQUEST_TYPE_CREATE: 'request-type:create',
    REQUEST_TYPE_UPDATE: 'request-type:update',
    REQUEST_TYPE_DELETE: 'request-type:delete',
    // PROFILE
    PROFILE_READ: 'profile:read',
    PROFILE_UPDATE: 'profile:update',

    // I18N
    I18N_READ: 'i18n:read',
    I18N_UPDATE: 'i18n:update',

    // SYSTEM SETTINGS
    SYSTEM_SETTINGS_MANAGE: 'system-settings:manage',

    // CREATOR SNAPSHOT (TikTok scrape)
    CREATOR_SNAPSHOT_CREATE: 'creator-snapshot:create',

    // CREATOR LEAD (eligibility + outreach pool)
    CREATOR_LEAD_READ: 'creator-lead:read',
    CREATOR_LEAD_CREATE: 'creator-lead:create',
    CREATOR_LEAD_MESSAGE: 'creator-lead:message',

    // AGENCY ACTIVITY
    AGENCY_ACTIVITY_READ: 'agency-activity:read',

    // VIOLATION
    VIOLATION_READ: 'violation:read',

    // PANEL
    PANEL_READ: 'panel:read',
    PANEL_ADMIN_READ: 'panel-admin:read',
    PANEL_MANAGERS_READ: 'panel-managers:read',
    PANEL_MANAGER_TRIAGE_READ: 'panel-manager-triage:read',
    PANEL_MONEY_READ: 'panel-money:read',
    VIOLATION_MANAGE: 'violation:manage',
    COMMUNITY_RULE_READ: 'community-rule:read',
    COMMUNITY_RULE_MANAGE: 'community-rule:manage',

    // SITE (ajans web sitesi vitrini)
    SITE_READ: 'site:read',
    SITE_MANAGE: 'site:manage',

    // GUIDE (mobil uygulama rehber videoları)
    GUIDE_READ: 'guide:read',
    GUIDE_MANAGE: 'guide:manage',

    // TOKEN MANAGEMENT
    TOKEN_MANAGEMENT_MANAGE: 'token-management:manage',

    // FILE
    FILE_CREATE: 'file:create',

    // EQUIPMENT
    EQUIPMENT_READ: 'equipment:read',
    EQUIPMENT_CREATE: 'equipment:create',
    EQUIPMENT_UPDATE: 'equipment:update',
    EQUIPMENT_DELETE: 'equipment:delete',
    EQUIPMENT_MANAGE: 'equipment:manage',

    // EARNINGS DISTRIBUTION
    EARNINGS_DISTRIBUTION_MANAGE: 'earnings-distribution:manage',

    // REFERRAL
    REFERRAL_READ: 'referral:read',
    REFERRAL_MANAGE: 'referral:manage',

    // MANAGER TIKTOK MAPPING
    MANAGER_MAPPING_READ: 'manager-mapping:read',
    MANAGER_MAPPING_CREATE: 'manager-mapping:create',
    MANAGER_MAPPING_DELETE: 'manager-mapping:delete',

    // GOAL TEMPLATE
    GOAL_TEMPLATE_READ: 'goal-template:read',
    GOAL_TEMPLATE_CREATE: 'goal-template:create',
    GOAL_TEMPLATE_UPDATE: 'goal-template:update',
    GOAL_TEMPLATE_DELETE: 'goal-template:delete',

    // GOAL INSTANCE
    GOAL_INSTANCE_READ: 'goal-instance:read',
    GOAL_INSTANCE_MANAGE: 'goal-instance:manage',

    // GOAL ASSIGNMENT
    GOAL_ASSIGNMENT_READ: 'goal-assignment:read',
    GOAL_ASSIGNMENT_CREATE: 'goal-assignment:create',
    GOAL_ASSIGNMENT_UPDATE: 'goal-assignment:update',
    GOAL_ASSIGNMENT_DELETE: 'goal-assignment:delete',

    // SURVEY
    SURVEY_READ: 'survey:read',
    SURVEY_CREATE: 'survey:create',
    SURVEY_UPDATE: 'survey:update',
    SURVEY_DELETE: 'survey:delete',
    SURVEY_MANAGE: 'survey:manage',
    SURVEY_RESPONSE_READ: 'survey-response:read',
    SURVEY_RESPONSE_CREATE: 'survey-response:create',
    // ANNOUNCEMENT
    ANNOUNCEMENT_READ: 'announcement:read',
    ANNOUNCEMENT_CREATE: 'announcement:create',
    ANNOUNCEMENT_UPDATE: 'announcement:update',
    ANNOUNCEMENT_DELETE: 'announcement:delete',
    ANNOUNCEMENT_MANAGE: 'announcement:manage',
} as const

export type Permission = typeof Permission[keyof typeof Permission]
